/** 金额展示 */
export function formatMoney(val: any): string {
  if (val == null || val === '') return '0.00'
  const n = Number(val)
  return Number.isNaN(n) ? '0.00' : n.toFixed(2)
}

/** 单行商品金额（单价 × 数量） */
export function dishLineTotal(item: any): number {
  const unit = Number(item && item.amount != null ? item.amount : 0)
  const qty = Number(item && item.number != null ? item.number : 1)
  return unit * qty
}

/** 商品小计 */
export function orderDishSubtotalFrom(form: any): string {
  if (!form) return '0.00'
  const list = form.orderDetailList || []
  if (list.length) {
    const sum = list.reduce(
      (total: number, item: any) => total + dishLineTotal(item),
      0,
    )
    return sum.toFixed(2)
  }
  return formatMoney(form.amount)
}

/** 抵扣金额 = 商品小计 - 实付 */
export function orderQuotaDiscountFrom(form: any): string {
  if (!form) return '0.00'
  const subtotal = Number(orderDishSubtotalFrom(form))
  const payable = Number(formatMoney(form.amount))
  const diff = Math.round((subtotal - payable) * 100) / 100
  return diff > 0 ? diff.toFixed(2) : '0.00'
}

/** 抵扣说明文案 */
export function orderDiscountLabel(form: any): string {
  if (!form) return '优惠抵扣'
  const buckets = Number(form.waterBucketsUsed || 0)
  if (buckets > 0) return `套餐数量抵扣（${buckets}桶）`
  return '优惠抵扣'
}

export function hasOrderDiscount(form: any): boolean {
  return Number(orderQuotaDiscountFrom(form)) > 0
}

export function payMethodLabel(payMethod: any, order?: any): string {
  const m = Number(payMethod)
  if (m === 4) return '电子票支付'
  // 历史：额度全额抵扣 / 套餐额度配送单曾误记为微信
  if (order) {
    const amount = Number(order.amount || 0)
    const used = Number(order.waterBucketsUsed || 0)
    const remark = String(order.remark || '')
    if ((used > 0 && amount === 0) || remark.indexOf('套餐额度抵扣') >= 0) {
      return '电子票支付'
    }
    const balance = Number(order.balancePayAmount)
    const online = Number(order.onlinePayAmount)
    const hasBalance = Number.isFinite(balance) && balance > 0
    const hasOnline = Number.isFinite(online) && online > 0
    if (hasBalance && hasOnline) {
      const onlineName = m === 3 ? '支付宝' : '微信'
      return `余额¥${formatMoney(balance)} + ${onlineName}¥${formatMoney(online)}`
    }
    if (hasBalance && !hasOnline) return '余额支付'
  }
  if (m === 1) return '微信支付'
  if (m === 2) return '余额支付'
  if (m === 3) return '支付宝支付'
  return '—'
}
